import type { IListProps } from '../list/list'

import { useEffect, useState } from 'react'

import { ButtonLink } from 'components/common/atoms'

import { List } from '../list'

import { Blur, ListWrapper } from './style'

export interface IShowMoreListProps extends IListProps {
  offset: number
  maxHeight: number
  itemHeight: number
}

export const ShowMoreList: React.FC<IShowMoreListProps> = ({
  dataSource,
  renderItem,
  maxHeight,
  itemHeight,
  offset,
}: IShowMoreListProps) => {
  const [isShowList, setIsShowList] = useState(false)
  const totalHeight = itemHeight * dataSource.length
  const [height, setHeight] = useState(Math.min(totalHeight, maxHeight))
  const [isShowBlur, setIsShowBlur] = useState(totalHeight > maxHeight)
  useEffect(() => {
    if (totalHeight < maxHeight || isShowList) {
      setHeight(totalHeight)
      setIsShowBlur(false)
    } else {
      setHeight(maxHeight)
      setIsShowBlur(true)
    }
  }, [isShowList, maxHeight, totalHeight])
  return (
    <div>
      <ListWrapper $height={height} $overflowY="hidden">
        {isShowBlur && <Blur data-testid="blur" $height={offset} />}
        <List dataSource={dataSource} renderItem={renderItem} />
      </ListWrapper>
      {totalHeight > maxHeight && (
        <ButtonLink
          text={isShowList ? 'Show Less' : 'Show More'}
          onClick={() => setIsShowList(!isShowList)}
        />
      )}
    </div>
  )
}
